// @ts-nocheck

import { createSelector } from 'reselect';

import { type Selector } from '../../../../../types/selectors';
import { selectBoomGlobalSkinId } from '../../../selectors/global/globalPrimary.selector';
import { type BoomSkinId } from '../../../types/global';

type BoomNavIconPropsType = {
  skinId: BoomSkinId;
};

const selectBoomNavIconProps: Selector<BoomNavIconPropsType> = createSelector([selectBoomGlobalSkinId], (skinId) => ({
  skinId,
}));

export default selectBoomNavIconProps;
